/**
 * @file Dictionnaire ANGLAIS (reference des cles : TranslationKey en derive). `{param}` = interpolation.
 */
export const EN = {
  // ---- general
  'app.title': 'Cat Gunner',
  'common.ok': 'OK',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.claim': 'Claim',
  'common.claimed': 'Claimed',
  'common.buy': 'Buy',
  'common.equip': 'Equip',
  'common.equipped': 'Equipped',
  'common.locked': 'Locked',
  'common.unlockAt': 'Unlocks at stage {stage}',
  'common.free': 'Free',
  'common.max': 'MAX',
  'common.level': 'Lv {level}',
  'common.back': 'Back',
  'common.confirm': 'Confirm',
  'common.continue': 'Continue',
  'common.x2': 'x2',
  // ---- currencies
  'currency.money': 'Money',
  'currency.ruby': 'Ruby',
  'currency.dia': 'Gems',
  'currency.petCoin': 'Pet coins',
  'currency.starGem': 'Star gems',
  'currency.coreForest': 'Forest cores',
  'currency.coreDesert': 'Desert cores',
  'currency.coreTundra': 'Tundra cores',
  'currency.wood': 'Wood',
  'currency.stone': 'Stone',
  'currency.ironOre': 'Iron ore',
  'currency.copperOre': 'Copper ore',
  'currency.silverOre': 'Silver ore',
  'currency.goldOre': 'Gold ore',
  'currency.crystal': 'Crystal',
  // ---- upgrades
  'upgrade.power': 'Power',
  'upgrade.speed': 'Speed',
  'upgrade.money': 'Money',
  'upgrade.power.desc': 'Damage x1.08 per level',
  'upgrade.speed.desc': 'Fire rate +8% per level',
  'upgrade.money.desc': 'Earnings x1.08 per level',
  'upgrade.buyMax': 'Buy max',
  'upgrade.gainLevels': '+{n} lv',
  // ---- stats
  'stat.damage': 'Damage',
  'stat.attackSpeed': 'Fire rate',
  'stat.money': 'Earnings',
  'stat.critChance': 'Crit chance',
  'stat.critDamage': 'Crit damage',
  'stat.moveSpeed': 'Move speed',
  'stat.range': 'Range',
  'stat.offlineHours': 'Offline cap (h)',
  'stat.offlineRate': 'Offline efficiency',
  'stat.rebirthGain': 'Ruby gain',
  'stat.diaGain': 'Gem gain',
  'stat.petCoinGain': 'Pet coin gain',
  'stat.xpGain': 'XP gain',
  'stat.harvestYield': 'Harvest yield',
  'stat.rareTreeChance': 'Rare tree chance',
  'stat.dps': 'DPS',
  // ---- HUD
  'hud.stage': 'Stage {stage}-{level}',
  'hud.boss': 'BOSS',
  'hud.wave': 'Wave {wave}/{max}',
  'hud.challenge': 'Challenge',
  'hud.farming': 'Farming',
  'hud.autoMove': 'Auto move',
  'hud.autoFire': 'Auto fire',
  'hud.stageClear': 'Stage Clear!',
  'hud.levelFailed': 'Time up!',
  'hud.ready': 'Ready...',
  'hud.go': 'Go!',
  'hud.barrier': 'Barrier',
  'hud.exitMode': 'Leave',
  // ---- menus
  'menu.weapons': 'Guns',
  'menu.skins': 'Skins',
  'menu.rebirth': 'Rebirth',
  'menu.missions': 'Missions',
  'menu.modes': 'Modes',
  'menu.settings': 'Settings',
  'menu.daily': 'Gift',
  'menu.hub': 'Hub',
  'feature.hub': 'Social hub',
  'menu.tickets': 'Tickets',
  // ---- weapons
  'weapons.title': 'Guns',
  'weapons.tab.inventory': 'Chest',
  'weapons.tab.collection': 'Collection',
  'weapons.tab.stars': 'Stars',
  'weapons.drawNormal': 'Draw',
  'weapons.drawEpic': 'Epic draw',
  'weapons.drawTen': 'x{n}',
  'weapons.dailyFree': 'Free daily gun',
  'weapons.merge': 'Merge',
  'weapons.autoMerge': 'Auto merge',
  'weapons.lock': 'Lock',
  'weapons.unlock': 'Unlock',
  'weapons.slot': 'Slot {n}',
  'weapons.chest': 'Chest {count}/{cap}',
  'weapons.chestEmpty': 'Your chest is empty: draw a gun above!',
  'weapons.buySlot': 'Extra slot',
  'weapons.dps': '{dps} DPS',
  'weapons.collectionReward': 'Complete grade {grade}',
  'weapons.mergeHint': 'Drag a gun onto another gun of the same grade to merge them (an equipped one too: then pick Merge or Equip). Drag a gun to a slot to equip it, or from a slot back to the chest to unequip it.',
  'behavior.single': 'Single',
  'behavior.pierce': 'Pierce',
  'behavior.shotgun': 'Shotgun',
  'behavior.explosive': 'Explosive',
  'behavior.laser': 'Laser',
  'behavior.missile': 'Missile',
  'behavior.blastSniper': 'Blast laser',
  // ---- stars
  'stars.title': 'Star upgrade',
  'stars.chance': 'Success {chance}',
  'stars.upgrade': 'Upgrade ({cost})',
  'stars.success': 'Success!',
  'stars.fail': 'Failed...',
  // ---- skins
  'skins.title': 'Skins',
  'skins.bonusHint': 'Bonuses apply even when the skin is not equipped.',
  // ---- rebirth
  'rebirth.title': 'Rebirth',
  'rebirth.desc': 'Restart from stage 1-1 and earn Rubies. Guns, skins and gems are kept.',
  'rebirth.gain': 'You will earn {rubies} Rubies',
  'rebirth.do': 'Rebirth',
  'rebirth.doX3': 'Rebirth x3 (daily)',
  'rebirth.notYet': 'Earn more money before rebirthing.',
  'rebirth.bonus.damage': 'Permanent damage',
  'rebirth.bonus.attackSpeed': 'Permanent fire rate',
  'rebirth.bonus.money': 'Permanent earnings',
  'rebirth.confirm': 'Rebirth now? Your stage and upgrades will reset.',
  // ---- missions / pass / daily
  'missions.title': 'Missions',
  'missions.daily': 'Daily',
  'missions.weekly': 'Weekly',
  'missions.achievements': 'Achievements',
  'missions.resetIn': 'Resets in {time}',
  'pass.title': 'Season pass',
  'pass.tier': 'Tier {tier}',
  'pass.free': 'Free',
  'pass.epic': 'Epic',
  'pass.unlockEpic': 'Unlock Epic track',
  'pass.endsIn': 'Season ends in {time}',
  'daily.title': 'Daily gift',
  'daily.day': 'Day {day}',
  // ---- modes
  'modes.title': 'Game modes',
  'modes.tickets': '{n} tickets',
  'modes.nextTicket': 'Next in {time}',
  'modes.best': 'Best: {best}',
  'modes.play': 'Play',
  'modes.sweep': 'Sweep',
  'modes.skeleton': 'Preview',
  'mode.main.title': 'Stage',
  'mode.monster.title': 'Monster defense',
  'mode.speedRun.title': 'Speed run',
  'mode.mine.title': 'Mine',
  'mode.boss.title': 'Wandering boss',
  'mode.raid.title': 'Raid',
  'mode.adventure.title': 'Adventure',
  'mode.fish.title': 'Aquarium',
  'mode.harvest.title': 'Harvest',
  'mode.hub.title': 'Cat plaza',
  'mode.result.win': 'Victory!',
  'mode.result.lose': 'Defeat',
  // ---- buffs
  'buff.moneyBuff': 'Money x3',
  'buff.powerBuff': 'Power x3',
  'buff.speedBuff': 'Speed x3',
  'buff.activate': 'Activate',
  'buff.freeIn': 'Free in {time}',
  // ---- offline
  'offline.title': 'While you were away',
  'offline.duration': 'Away for {time}',
  'offline.capped': 'Offline cap reached!',
  'offline.earned': 'Your cats earned {money}',
  'offline.kills': '{kills} trees chopped',
  'offline.double': 'x2 for {cost} gems',
  // ---- settings
  'settings.title': 'Settings',
  'settings.language': 'Language',
  'settings.sound': 'Sound',
  'settings.music': 'Music',
  'settings.mute': 'Mute',
  'settings.eco': 'Eco mode',
  'settings.quality': 'Quality',
  'settings.quality.low': 'Low',
  'settings.quality.high': 'High',
  'settings.quality.hint': 'Low: lighter image (1x instead of 2x), no glow, fewer particles. Smoother and easier on the battery.',
  'settings.autoLowQuality': 'Glow turned off for this session to keep the game smooth.',
  'settings.vibration': 'Vibration',
  'settings.damageNumbers': 'Damage numbers',
  'settings.fxSelf': 'My effects (aura, shots, fireworks)',
  'settings.fxOthers': "Other players' effects",
  'settings.reduceMotion': 'Reduce motion',
  'settings.autoMove': 'Auto move',
  'settings.autoFire': 'Auto fire',
  'settings.autoUpgrade': 'Auto upgrade',
  'settings.resetSave': 'Reset save',
  'settings.resetConfirm': 'Erase all progress? This cannot be undone.',
  'settings.export': 'Export save',
  'settings.import': 'Import save',
  // ---- tutorial
  'tutorial.upgrade': 'Tap POWER to make your cat stronger!',
  'tutorial.chop': 'Your cat fires on its own: chop {n} trees to earn money! ({done}/{n})',
  'tutorial.gunOpen': 'Open the GUNS menu.',
  'tutorial.gunBuy': 'Draw a new gun with your gems.',
  'tutorial.gunEquip': 'Equip your new gun: one cat per gun!',
  'tutorial.skip': 'Skip tutorial',
  // ---- toasts
  'toast.unlocked': 'Unlocked: {name}',
  'toast.saved': 'Game saved',
  'toast.newWeapon': 'New gun: {name}',
  'toast.merged': 'Merged into {name}!',
  'toast.mergedAuto': 'Auto-merge: {name} (grade {grade})',
  'toast.rebirth': 'Rebirth! +{rubies} Rubies',
  'toast.missionDone': 'Mission complete!',
  'toast.cloudLoaded': 'Cloud save loaded (it was more recent than this device).',
  'toast.loadFailed': 'Save could not be loaded, a backup was used.',
  // ---- errors (Result.error)
  'error.notEnoughFunds': 'Not enough currency',
  'error.locked': 'Locked',
  'error.maxLevel': 'Max level reached',
  'error.invalidTarget': 'Invalid target',
  'error.inventoryFull': 'Chest is full',
  'error.cannotMerge': 'These guns cannot be merged',
  'error.notOwned': 'Not owned',
  'error.alreadyOwned': 'Already owned',
  'error.cooldown': 'Not available yet',
  'error.noTickets': 'No tickets left',
  'error.wrongMode': 'Not available in this mode',
  'error.unknownId': 'Unknown item',
  'error.invalidArgument': 'Invalid action',
  'error.nothingToClaim': 'Nothing to claim',
  // ---- features
  'feature.weapons': 'Guns',
  'feature.gacha': 'Gun draws',
  'feature.chest': 'Chest',
  'feature.skins': 'Skins',
  'feature.missions': 'Missions',
  'feature.pass': 'Season pass',
  'feature.daily': 'Daily gift',
  'feature.buffs': 'Buffs',
  'feature.rebirth': 'Rebirth',
  'feature.stars': 'Star upgrade',
  'feature.relics': 'Relics',
  'feature.pets': 'Pets',
  'feature.fish': 'Aquarium',
  'feature.modeSelect': 'Game modes',
  'feature.autoMerge': 'Auto merge',
  // ---- ui additions (ecrans, modales)
  'common.unlockRebirths': 'Unlocks after {n} rebirths',
  'weapons.unequip': 'Unequip',
  'weapons.mergeAll': 'Merge all',
  'weapons.drawResult': 'You got!',
  'weapons.tapToClose': 'Tap to continue',
  'weapons.noWeapon': 'Empty',
  'weapons.selectHint': 'Tap a gun, then a slot to equip it.',
  'weapons.detail.grade': 'Grade {grade}',
  'weapons.detail.mergeTo': 'Merge → {grade}',
  'weapons.detail.hint': 'Tap a slot to equip it there, or drag the weapon.',
  'weapons.detail.freeSlot': 'Slot {n} is free: equip it!',
  'weapons.detail.vsSlot': '{delta} DPS compared to slot {n}',
  'weapons.detail.sameAs': 'Same DPS as slot {n}',
  'weapons.detail.inSlot': 'Equipped in slot {n}',
  'stars.level': 'Star level {level}/{max}',
  'stars.multiplier': 'Slot power {mult}',
  'stars.noWeapon': 'Equip a gun in this slot first.',
  'pass.xp': '{xp} XP',
  'daily.comeBack': 'Come back tomorrow!',
  'missions.empty': 'No missions yet.',
  'rebirth.count': 'Rebirths: {n}',
  'settings.copy': 'Copy',
  'settings.copied': 'Copied!',
  'settings.importHint': 'Paste a save here...',
  'settings.importFailed': 'This save could not be imported.',
  'settings.debug': 'Debug (GPU)',
  'skins.total': 'Total skin bonus',
  'skins.confirmGems': 'Spend gems on this skin?',
  'skins.tab.cats': 'Cats',
  'skins.tab.ammo': 'Ammo',
  'skins.tab.shotfx': 'Shot FX',
  'skins.tab.pets': 'Pets',
  'pets.hint': 'Buy pets with the coins earned in Monster mode. Up to 3 equipped: their bonus applies while equipped. Tap an equipped pet to remove it.',
  'pets.slots': 'Equipped',
  'pets.locked': 'together with Monster mode',
  'shotfx.hint': 'Cosmetic only: a big effect layered on all your weapons (muzzle blast, trail, impact explosion). Shop only.',
  'hubshop.title': 'Hub shop',
  'hubshop.tab.fx': 'FX',
  'hubshop.tab.fireworks': 'Fireworks',
  'fireworks.hint': 'Cosmetic only: pick the firework you launch from the hub. "Classic" uses the colors of your ammo.',
  'hub.catnip': 'Catnip',
  'hub.link.connected': 'Online',
  'hub.link.connecting': 'Connecting…',
  'hub.link.solo': 'Offline',
  'fx.hint': 'Cosmetic only: an aura that constantly surrounds your cat. Shop only.',
  'fx.none': 'None',
  'hub.zoomIn': 'Zoom +',
  'hub.zoomOut': 'Zoom −',
  'hub.zoomReset': 'Reset',
  'hub.stow': 'Stow weapon',
  'hub.unstow': 'Draw weapon',
  'hub.firework': 'Fireworks',
  'hub.fx': 'FX',
  'hub.shop': 'Skin shop',
  'ammo.hint': 'Cosmetic only: pick the look of your shots, trails and impacts for each weapon type.',
  'result.rewards': 'Rewards',
  'menu.online': "Online",
  'online.title': "Online",
  'online.tab.boards': "Rankings",
  'online.tab.friends': "Friends",
  'online.tab.mail': "Mail",
  'online.tab.events': "Events",
  'online.offline': "You are offline. Rankings, friends, mail and events need a connection.",
  'online.retry': "Retry",
  'online.refresh': "Refresh",
  'online.loading': "Loading…",
  'online.empty': "Nothing here yet.",
  'online.nick.label': "Nickname",
  'online.nick.save': "Save",
  'online.nick.saved': "Nickname saved",
  'online.nick.hint': "3 to 24 letters, digits, - or _. Other players see it.",
  'online.board.best_stage': "Best stage",
  'online.board.boss_level': "Boss: wins",
  'online.board.raid_level': "Raid: level",
  'online.board.catnip_weekly': "Catnip (this week)",
  'online.board.you': "You",
  'online.board.noScore': "No score yet",
  'online.board.resets': "Resets in {time}",
  'online.friend.add': "Add a friend",
  'online.friend.placeholder': "Their nickname",
  'online.friend.addBtn': "Add",
  'online.friend.sent': "Invitation sent",
  'online.friend.added': "You are now friends",
  'online.friend.accept': "Accept",
  'online.friend.remove': "Remove",
  'online.friend.join': "Join",
  'online.friend.requests': "Requests",
  'online.friend.pending': "Waiting for an answer",
  'online.friend.list': "Friends",
  'online.friend.on': "online",
  'online.friend.off': "offline",
  'online.mail.claim': "Claim",
  'online.mail.delete': "Delete",
  'online.mail.from': "From {name}",
  'online.mail.empty': "Your mailbox is empty.",
  'online.event.ongoing': "Ongoing",
  'online.event.upcoming': "Coming soon",
  'online.event.ends': "Ends in {time}",
  'online.event.starts': "Starts in {time}",
  'online.event.claim': "Claim reward",
  'online.event.claimed': "Reward claimed",
  'online.event.multiplier': "Catnip x{n}",
  'online.event.reward': "Reward: {reward}",
  'online.event.progress': "{n} / {max}",
  'online.shop.title': "Event shop",
  'online.shop.buy': "Buy",
  'online.shop.balance': "Your catnip: {n}",
  'online.shop.empty': "The event shop opens during special events.",
  'online.shop.left': "{n} left",
  'online.offer.weekend_pack': "Weekend pack",
  'online.offer.weekend_epic': "Weekend epic draw",
  'online.rewardReceived': "Reward received!",
  'online.friendNotInHub': "This friend is not in a public hub room: you joined a normal one.",
  'online.reportSent': "Report sent, thank you.",
  'online.err.generic': "Something went wrong.",
  'online.err.offline': "You are offline.",
  'online.err.network': "Connection problem, try again.",
  'online.err.timeout': "The server is slow to answer, try again.",
  'online.err.username_taken': "This nickname is already taken.",
  'online.err.bad_request': "This value is not allowed.",
  'online.err.rate_limited': "Too fast, wait a moment.",
  'online.err.insufficient_funds': "Not enough catnip.",
  'online.err.limit_reached': "You reached the limit for this offer.",
  'online.err.not_found': "Player not found.",
  'online.err.already_claimed': "Already claimed.",
  'online.err.goal_not_reached': "Goal not reached yet.",
  'online.err.event_inactive': "This event is over.",
  'online.err.forbidden': "Not available right now.",
  'online.err.friend_limit': "Friends list is full.",
  'hub.chat': "Chat",
  'hub.emotes': "Emotes",
  'hub.players': "Players",
  'hub.chat.placeholder': "Say something…",
  'hub.chat.send': "Send",
  'hub.chat.empty': "No messages yet. Say hi!",
  'hub.chat.offline': "Chat works when you are online in the hub.",
  'hub.chat.block': "Block",
  'hub.chat.report': "Report",
  'hub.chat.addFriend': "Add friend",
  'hub.emote.wave': "Wave",
  'hub.emote.heart': "Love",
  'hub.emote.laugh': "Laugh",
  'hub.emote.dance': "Dance",
  'hub.emote.sleep': "Sleep",
  'hub.emote.angry': "Angry",
  'hud.bossLevel': "Lv {n}",
  'hud.bossPhase': "Phase {n}/{max}",
  'hud.bossShield': "Shield: {n} pylon(s)",
  'hud.raidEggs': "{n} egg(s) to destroy",
  'hud.bossShieldUp': "Shield! Break the pylons",
  'hud.bossPhaseUp': "Phase {n}/{max}",
  'mode.result.score': "Score {n}",
  'raid.hatch': "An egg hatched and healed the dragon!",
  'modes.level': "Level {n}",
  'modes.bossHint': "Break the crystal pylons to drop the shield. Faster win = better rewards.",
  'modes.raidHint': "Destroy the dragon eggs before they hatch and heal it.",
} as const;

export type TranslationKey = keyof typeof EN;
